<template>
  <div ref="playerContainer" class="theoplayer-container video-js theoplayer-skin vjs-16-9"></div>
</template>

<script>
import 'theoplayer/ui.css'
import * as THEOplayer from 'theoplayer'
export default {
  props: {
    playerLicense: {
      type: String,
      required: true,
      default: ''
    },
    src: {
      type: String,
      required: true,
      default: ''
    },
    subscriberToken: {
      type: String,
      required: true,
      default: ''
    }
  },
  data () {
    return {
    }
  },
  methods: {
    initializePlayer () {
      let element = this.$refs.playerContainer
      let configuration = {
        license: this.playerLicense
      }
      let player = new THEOplayer.Player(element, configuration)
      player.source = {
        sources: [
          {
            type: 'theolive',
            src: this.src,
            subscriberToken: this.subscriberToken
          }
        ]
      }
    }
  },
  mounted () {
    setTimeout(() => {
      this.initializePlayer()
    }, 1000)
  }
}
</script>

<style>
</style>



// WEBPACK FOOTER //
// src/components/sports/bettingoffer/live/THEOPlayer.vue